/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Select_AllInputs */



/**
* | output |
* | --- |
* | "Select All" |
*
* @param {Context_Menu_Select_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_select_all = /** @type {((inputs?: Context_Menu_Select_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Select_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout selectionner")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбрать все")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全选")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सबका चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar tudo")
	return /** @type {LocalizedString} */ ("Select All")
});